/**
 * (c) 2022, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
const Container = {
  variants: {
    "sidebar-header": {
      bg: "black",
      p: 0,
      maxW: "unset",
    },
  },
};

export default Container;
